import React, { useRef } from 'react';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Box, Typography } from '@mui/material';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import './styles.scss';

const CustomRichTextField = React.forwardRef(
  ({
    onChange, onBlur, value, name, label, placeholder, defaultValue = '', options, toolbarCustomButtons, editorStyle,
  }: any, ref) => {
    const [editorState, setEditorState] = React.useState(() => EditorState.createEmpty());
    const isInitialized = useRef(false);

    React.useEffect(() => {
      if (isInitialized.current || !value || value?.trim() === '<p></p>') {
        return;
      }
      const contentBlock = htmlToDraft((value.startsWith('<img>') ? `<p>${value}</p>` : value) || '');
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      setEditorState(EditorState.createWithContent(contentState));
      isInitialized.current = true;
    }, [value]);

    React.useEffect(() => {
      if (onChange) {
        let content = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        content = content.replace(/<div style="text-align:none;"><img/g, '<div style="text-align:center;"><img');
        onChange(content);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editorState]);

    return (
      <Box>
        <Typography variant="body1">{label}</Typography>
        <Editor
          placeholder={placeholder}
          editorState={editorState}
          toolbar={options === undefined ? {
            options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'emoji', 'remove', 'history', 'image'],
          } : options}
          toolbarClassName="richTextToolbar"
          wrapperClassName="richTextWrapper"
          editorClassName="richTextEditor"
          onEditorStateChange={setEditorState}
          toolbarCustomButtons={toolbarCustomButtons}
          editorStyle={editorStyle}
        />

      </Box>
    );
  },
);

CustomRichTextField.defaultProps = {
  toolbarCustomButtons: undefined,
};

export default CustomRichTextField;
